// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"198":"b6eab37e","219":"aa691a7a","520":"0fdd3c27"}[chunkId] + ".chunk.css";
};